
import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useSocialMediaSettings } from "@/hooks/useSocialMediaSettings";

const SocialMediaLinks = () => {
  const { socialLinks, socialFlags, isLoading } = useSocialMediaSettings();

  if (isLoading) {
    return (
      <div className="flex space-x-4">
        <div className="h-5 w-5 animate-pulse rounded bg-dark-muted"></div>
        <div className="h-5 w-5 animate-pulse rounded bg-dark-muted"></div>
        <div className="h-5 w-5 animate-pulse rounded bg-dark-muted"></div>
        <div className="h-5 w-5 animate-pulse rounded bg-dark-muted"></div>
      </div>
    );
  }

  const socialMediaItems = [
    {
      name: 'Facebook',
      url: socialLinks.facebook,
      icon: Facebook,
      enabled: socialFlags.facebook
    },
    {
      name: 'Instagram', 
      url: socialLinks.instagram,
      icon: Instagram,
      enabled: socialFlags.instagram
    },
    {
      name: 'LinkedIn',
      url: socialLinks.linkedin,
      icon: Linkedin,
      enabled: socialFlags.linkedin
    },
    {
      name: 'Twitter',
      url: socialLinks.twitter,
      icon: Twitter,
      enabled: socialFlags.twitter
    }
  ];

  const enabledItems = socialMediaItems.filter(item => item.enabled);

  if (enabledItems.length === 0) {
    return null;
  }

  return (
    <div className="flex space-x-4">
      {enabledItems.map((item) => {
        const IconComponent = item.icon;
        return (
          <a
            key={item.name}
            href={item.url}
            className="text-dark-muted transition-colors hover:text-white"
            target="_blank"
            rel="noreferrer"
            aria-label={`Visit our ${item.name} page`}
          >
            <IconComponent className="h-5 w-5" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialMediaLinks;
